var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEnviar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.8346 8.77654L10.3339 12.1102M21.1721 1.03252C21.2828 0.996134 21.402 0.990146 21.5162 1.01524C21.6303 1.04034 21.7347 1.0955 21.8175 1.17443C21.9002 1.25337 21.958 1.35288 21.9842 1.4616C22.0104 1.57032 22.0039 1.68387 21.9656 1.78925L15.0528 20.602C15.0115 20.7145 14.9356 20.8125 14.835 20.8834C14.7344 20.9543 14.6138 20.9947 14.4887 20.9995C14.3637 21.0043 14.2401 20.9732 14.1338 20.9103C14.0276 20.8473 13.9437 20.7554 13.8929 20.6465L10.1367 12.5991C10.0735 12.4653 9.96099 12.3581 9.82046 12.298L1.36977 8.71987C1.25576 8.67139 1.15963 8.59148 1.09381 8.49044C1.02798 8.38941 0.995481 8.2719 1.00051 8.15309C1.00553 8.03429 1.04785 7.91965 1.122 7.82398C1.19615 7.72832 1.29871 7.65602 1.41645 7.61644L21.1721 1.03252Z",
    stroke: "#F4F4F4",
    strokeWidth: 1.55597,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnviar);
export default __webpack_public_path__ + "static/media/Enviar.5b67ed10c258b4c0dc6d6e2156adceaf.svg";
export { ForwardRef as ReactComponent };